var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
var Context = createContext(null);
export var BillingIsSameProvider = function (_a) {
    var children = _a.children;
    var _b = useState(true), billingIsSame = _b[0], setBillingIsSame = _b[1];
    var handleBillingIsSameChange = function (ev) {
        setBillingIsSame(ev.target.checked);
    };
    return (_jsx(Context.Provider, __assign({ value: {
            billingIsSame: billingIsSame,
            handleBillingIsSameChange: handleBillingIsSameChange,
        } }, { children: children })));
};
export var useBillingIsSame = function () {
    var context = useContext(Context);
    if (!context)
        throw new Error('BillingIsSameProvider not found in root');
    return context;
};
//# sourceMappingURL=BillingIsSame.js.map